module.exports = __webpack_public_path__ + "static/about-1e28f64131ed8ee82c39b2e94af60d52.jpeg";